var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonicaLicniProfilOrganizacija(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#159497;}.cls-2{fill:#6e5dd8;}.cls-3{fill:#fff;}.cls-3,.cls-4{stroke:#6e5dd8;}.cls-3,.cls-4,.cls-6{stroke-miterlimit:10;stroke-width:1.5px;}.cls-4,.cls-6{fill:none;}.cls-5{fill:#fa7268;}.cls-6{stroke:#aa6276;}.cls-7{fill:#aa6276;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "600x325") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.75,293.6c9.93-21.64,20.09-43.64,35.91-61.44S371.09,201,394.88,202.1s47.26,19.76,48.35,43.55c.86,18.59-10.93,35.1-22.23,49.88,6.07-12.54,26-13,35.34-2.64s9,26.78,2.73,39.22-17.3,21.73-28.32,30.25c8.83-4.23,20.11-.48,26.33,7.09s8,18,6.87,27.77A55.16,55.16,0,0,1,438.82,437c-13.75,8.61-133.76,5.25-133.76,5.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 442.8,
    cy: 148.63,
    r: 8.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.74,
    y: 50.95,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.78,
    y: 56.45,
    width: 290.51,
    height: 385.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 132.47,
    y: 93.92,
    width: 47.22,
    height: 59.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.43,
    y: 93.92,
    width: 47.22,
    height: 59.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 292.38,
    y: 93.92,
    width: 47.22,
    height: 59.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 132.47,
    y: 186.52,
    width: 47.22,
    height: 59.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.43,
    y: 186.52,
    width: 47.22,
    height: 59.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 292.38,
    y: 186.52,
    width: 47.22,
    height: 59.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 132.47,
    y: 279.13,
    width: 47.22,
    height: 59.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.43,
    y: 279.13,
    width: 47.22,
    height: 59.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 292.38,
    y: 279.13,
    width: 47.22,
    height: 59.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 132.47,
    y: 368.03,
    width: 207.12,
    height: 73.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 201.51,
    y1: 368.03,
    x2: 201.51,
    y2: 441.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 270.55,
    y1: 368.03,
    x2: 270.55,
    y2: 441.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 132.47,
    y1: 139.8,
    x2: 179.69,
    y2: 139.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 212.43,
    y1: 139.8,
    x2: 259.64,
    y2: 139.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 292.38,
    y1: 139.8,
    x2: 339.6,
    y2: 139.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 132.47,
    y1: 232.41,
    x2: 179.69,
    y2: 232.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 212.43,
    y1: 232.41,
    x2: 259.64,
    y2: 232.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 292.38,
    y1: 232.41,
    x2: 339.6,
    y2: 232.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 132.47,
    y1: 325.01,
    x2: 179.69,
    y2: 325.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 212.43,
    y1: 325.01,
    x2: 259.64,
    y2: 325.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 292.38,
    y1: 325.01,
    x2: 339.6,
    y2: 325.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 41.24,
    y: 145.76,
    width: 49.55,
    height: 295.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M434.72,71.23A255.38,255.38,0,0,0,268.84,250.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M263.72,236.83a.9.9,0,0,1,1.12.59l4.14,13,10-9.25a.89.89,0,1,1,1.21,1.31l-11.07,10.2a.87.87,0,0,1-.83.21.9.9,0,0,1-.63-.6L263.14,238a1,1,0,0,1,0-.5A.91.91,0,0,1,263.72,236.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "154.58 427.23 141.97 449.05 167.18 449.05 154.58 427.23"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonicaLicniProfilOrganizacija);
export default __webpack_public_path__ + "static/media/Ikonica-Licni_profil-organizacija.49453ba964dc4e292422f3a05cc4fa42.svg";
export { ForwardRef as ReactComponent };